import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Briefcase = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 10H22V9C22 6.243 19.757 4 17 4H15C12.243 4 10 6.243 10 9V10H9C6.243 10 4 12.243 4 15V23C4 25.757 6.243 28 9 28H23C25.757 28 28 25.757 28 23V15C28 12.243 25.757 10 23 10ZM12 9C12 7.346 13.346 6 15 6H17C18.654 6 20 7.346 20 9V10H12V9ZM6 15C6 13.346 7.346 12 9 12H23C24.654 12 26 13.346 26 15V16.544C25.246 17.162 23.126 18.709 19.968 19.506C19.724 17.533 18.038 16 15.999 16C13.96 16 12.274 17.533 12.03 19.507C8.871 18.709 6.751 17.162 5.998 16.545V15H6ZM17.994 19.877C17.36 19.955 16.695 20 16 20C15.305 20 14.641 19.955 14.006 19.877C14.07 18.832 14.938 18 16 18C17.062 18 17.93 18.831 17.994 19.877ZM23 26H9C7.346 26 6 24.654 6 23V19.028C7.908 20.289 11.352 22 16 22C20.648 22 24.092 20.288 26 19.028V23C26 24.654 24.654 26 23 26Z" />
	</svg>
);

export default Briefcase;
